import Reflux from 'reflux';

const ServerAvailabilityActions = Reflux.createActions([
  'reportError',
  'reportSuccess',
]);

export default ServerAvailabilityActions;
